'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = deprecateComponent;
function deprecateComponent(MyComponent, message) {
  var warning = message || (MyComponent && MyComponent.name ? MyComponent.name + ' will be removed.' : (typeof MyComponent === 'undefined' ? 'undefined' : _typeof(MyComponent)) + ' will be removed.');

  if (process.env.NODE_ENV !== 'production') {
    console.warn('Deprecation: ' + warning);
  }

  return MyComponent;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/utils/deprecateComponent.js
// module id = 1822
// module chunks = 32